import { useQuery } from '@tanstack/react-query'

import { GetSimulacaoPorId } from '@/features/simulacao/services/get-simulacao-por-id.service'
import type { TGetSimulacaoResponse } from '@/types/simulacao'

export const useSimulacaoPorId = (simulacaoId: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['simulacao', simulacaoId],
    queryFn: async () => new GetSimulacaoPorId().execute(simulacaoId).then((response) => response.data),
    select: mapperSimulacaoResponse,
    enabled,
  })
}

export function mapperSimulacaoResponse(data: TGetSimulacaoResponse) {
  return {
    ...data,
    entrada: data.entrada.map(({ valor }) => ({ quantidade: 1, valor })),
    mensais: data.mensais.flatMap(({ parcelas }) => parcelas.map(({ valor }) => ({ valor, quantidade: 1 }))),
    intermediarias: data.intermediarias.flatMap(({ parcelas }) =>
      parcelas.map(({ valor }) => ({ valor, quantidade: 1 })),
    ),
    posConclusao: data.posConclusao.map(({ valor }) => ({ valor, quantidade: 1 })),
    intermediariasPosConclusao: data.intermediariasPosConclusao?.flatMap(({ parcelas }) =>
      parcelas.map(({ valor }) => ({ valor, quantidade: 1 })),
    ),
  }
}
